import type { LegacyTimelineEventData } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { SupportTicketTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import ClockRewindIcon from "@redotech/redo-icons/clock-rewind_filled.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { formatSentenceCase } from "@redotech/util/string";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const LegacyTimelineEvent = memo(function LegacyTimelineEvent({
  event,
  data,
}: {
  event: SupportTicketTimelineEventResponse;
  data: LegacyTimelineEventData;
}) {
  const detail = data.longDescription ?? data.message;

  return (
    <Flex align="flex-start" className={styles.card} gap="sm">
      <Flex
        align="center"
        className={`${styles.icon} ${styles.iconOrange}`}
        justify="center"
      >
        <ClockRewindIcon />
      </Flex>
      <Flex className={styles.content} dir="column" gap="xxs">
        <Text fontSize="xs" fontWeight="medium" textColor="primary">
          {data.shortDescription || formatSentenceCase(data.legacyEventType)}
        </Text>
        {detail && (
          <Text className={styles.details} fontSize="xxs" textColor="secondary">
            {detail}
          </Text>
        )}
        <EventTimestamp event={event} />
      </Flex>
    </Flex>
  );
});
